export const DEFAULT_CONTRIBUTION_RANGE = [ 0, 3, 6, 9, 10 ];

// 由浅到深
export const DEFAULT_THEME = [ '#ebedf0', '#c6e48b', '#7bc96f', '#239a3b', '#196127', '#f00' ];

// 万圣节主题
export const THEME_HALLOWEEN = [ '#ebedf0', '#FFEE4A', '#FFC501', '#FE9600', '#03001C' ];

export const DEFAULT_ROW_NUMBER = 7;

export const DEFAULT_DATE_FORMAT = 'YYYY-MM-DD';

export const DATE_ROW_COUNT = 6;

export const THEME_MAP = {
  'halloween': THEME_HALLOWEEN,
}

/*
['#d8e9f2', '#f9ef9d', '#fbe793', '#fdde8a', '#fdcf7d']
['#d8e9f2', '#fdc070', '#fdb163', '#fa9e59', '#f88a50']
['#d8e9f2', '#f57647', '#ee6544', '#e55648', '#db484c']
['#d8e9f2', '#d0394d', '#bf2649', '#ae1345', '#9e0142']
*/
